import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Autocomplete from "../../component/autocomplete";
import xlsx from "xlsx";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      setStatus: "",
      submittedDateFrom: "",
      submittedDateTo: "",
      status: "",
      activeStatus: "",
      setBranch: "",
      setPrincipal: "",
      lovPrincipal: [],
      princid: "",
      lovBranch: [],
      export: false,
      originOrgid: "",
      customerId: 0,
      customerName: "",
      bupotexist: "",
      expDate: "",
      awbcabang: "",
      awbho: "",
    };
  }

  componentDidMount = () => {
    // let url = '/api/traces/v1/report/reportho'
    // let param = {
    //     org_id: this.state.user.org_id,
    //     source: 'arman'
    // }
    // this.setState({ loading: true })
    // requester.postTraces(url, param, {
    //     success: function (response) {
    //         let { data } = response.data
    //         data.data.map((item, index) => {
    //             item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
    //             item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
    //             return item
    //         })
    //         this.setState({ loading: false, dataTable: data.data, baseTable: data.data })
    //     }.bind(this),
    //     error: function (e) {
    //         this.setState({ loading: false })
    //     }.bind(this)
    // })
    this.getPrincipal();
    this.getBranch();
  };

  onSelectCustomer = (suggestions, index) => {
    let customer_id = 0;
    let customer_name = "";
    this.setState({ customerId: 0, customerName: "" });
    customer_id = suggestions.value ? suggestions.value : 0;
    customer_name = suggestions.text ? suggestions.text : null;
    this.setState({ customerId: customer_id, customerName: customer_name });
    // console.log(customerSave)
  };

  onChangeAutocompleteCust = (q) => {
    this.setState({ customerId: 0, customerName: "" });
    let param = {
      // branch_id: this.state.user.org_id,
      branch_id: this.state.setBranch,
      customer_name: q,
    };
    let container = [];
    this.setState({ customerId: 0, customerName: "" });
    return new Promise((resolve) => {
      requester.postOracle("/api/orafin/v1/participant/customer", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_NAME;
            item.value = item.CUSTOMER_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  getBranch = () => {
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //     return item.org_id
    // })

    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });

    if (this.state.user.origin === "CAB") {
      this.state.originOrgid = this.state.user.org_id;
      this.state.setBranch = this.state.user.org_id;
    }

    // this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.originOrgid);
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "BRANCH",
          accessor: "BRANCH",
          filterable: true,
          width: 200,
        },
        {
          Header: "SUBMIT_DATE_CLAIM",
          accessor: "SUBMIT_DATE_CLAIM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "AWB_NO_CABANG",
          accessor: "AWB_NO_CABANG",
          filterable: true,
          width: 200,
        },
        {
          Header: "AWB_NO_CABANG_SUBMIT_DATE",
          accessor: "AWB_NO_CABANG_SUBMIT_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "AWB_RECEIPT_DATE_HO",
          accessor: "AWB_RECEIPT_DATE_HO",
          filterable: true,
          width: 200,

          // ,filterable: true
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "PRINCIPAL_CODE",
          accessor: "PRINCIPAL_CODE",
          filterable: true,
          width: 200,
        },
        {
          Header: "AWB_NO_HO",
          accessor: "AWB_NO_HO",
          filterable: true,
          width: 200,
        },
        {
          Header: "LT_CAB_HO", // BARU
          accessor: "LT_CAB_HO",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "AWB_RECEIPT_DATE_PRINCIPAL",
          accessor: "AWB_RECEIPT_DATE_PRINCIPAL",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "PRINCIPAL_CLAIM_RECEIPT_DATE",
          accessor: "PRINCIPAL_CLAIM_RECEIPT_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "LT_HO_PRINCIPAL", // BARU
          accessor: "LT_HO_PRINCIPAL",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "PAYMENT_METHOD",
          accessor: "PAYMENT_METHOD",
          filterable: true,
          width: 200,
        },
        {
          Header: "KWITANSI",
          accessor: "KWITANSI",
          filterable: true,
          width: 200,
        },
        {
          Header: "CLAIM_NUMBER",
          accessor: "CLAIM_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "STATUS",
          accessor: "STATUS",
          filterable: true,
          width: 200,
        },
        {
          Header: "APPROVED_REJECTED_DATE",
          accessor: "APPROVED_REJECTED_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "REASON_REJECTED",
          accessor: "REASON_REJECTED",
          filterable: true,
          width: 200,
        },
        {
          Header: "LT_APPROVAL_PRINCIPAL", // BARU
          accessor: "LT_APPROVAL_PRINCIPAL",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "CUST_INVOICE_NO", //BARU
          accessor: "CUST_INVOICE_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "PRINCIPAL_CLAIM_ID",
          accessor: "PRINCIPAL_CLAIM_ID",
          filterable: true,
        },
        {
          Header: "PRINCIPAL STATUS",
          accessor: "PRINCIPAL_STATUS",
          filterable: true,
          width: 200,
        },
        {
          Header: "CUSTOMER_GROUP",
          accessor: "CUSTOMER_GROUP",
          filterable: true,
          width: 200,
        },
        {
          Header: "CUSTOMER_NAME",
          accessor: "CUSTOMER_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_NUMBER",
          accessor: "PROGRAM_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_TYPE",
          accessor: "PROGRAM_TYPE",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_NUMBER",
          accessor: "PROGRAM_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_DESCRIPTIONS",
          accessor: "PROGRAM_DESCRIPTIONS",
          filterable: true,
          width: 200,
        },
        {
          Header: "REF_NUMBER/SKP",
          accessor: "REF_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "TRACES_NUMBER",
          accessor: "TRACES_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "START_DATE_PROGRAM",
          accessor: "START_DATE_PROGRAM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "END_DATE_PROGRAM",
          accessor: "END_DATE_PROGRAM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "CLAIM_EXP_DATE",
          accessor: "CLAIM_EXP_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },

        {
          Header: "NILAI_DPP",
          accessor: "NILAI_DPP",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "NILAI_PPN",
          accessor: "NILAI_PPN",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "TOTAL_CLAIM",
          accessor: "TOTAL_CLAIM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "PPH_TYPE",
          accessor: "PPH_TYPE",
          filterable: true,
          width: 200,
        },
        {
          Header: "PPH_RATE",
          accessor: "PPH_RATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "NILAI_PPH",
          accessor: "NILAI_PPH",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "CLAIM_NET",
          accessor: "CLAIM_NET",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "NO_NPWP_RELASI",
          accessor: "NO_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "NAMA_NPWP_RELASI",
          accessor: "NAMA_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "ALAMAT_NPWP_RELASI",
          accessor: "ALAMAT_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "TAX_NO",
          accessor: "TAX_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "TAX_DATE",
          accessor: "TAX_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "SKB_NUMBER",
          accessor: "SKB_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "AR_INVOICE_NUMBER",
          accessor: "AR_INVOICE_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "SUPPLIER_NAME",
          accessor: "SUPPLIER_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "SUPPLIER_SITE",
          accessor: "SUPPLIER_SITE",
          filterable: true,
          width: 200,
        },
        {
          Header: "AP_INVOICE_NUM",
          accessor: "AP_INVOICE_NUM",
          filterable: true,
          width: 200,
        },
        {
          Header: "COVER_LETTER_NUMBER",
          accessor: "COVER_LETTER_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "COVER_LETTER_DATE",
          accessor: "COVER_LETTER_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "AR_INVOICE_NUMBER",
          accessor: "AR_INVOICE_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "RECEIPT_NO_CABANG",
          accessor: "RECEIPT_NO_CABANG",
          filterable: true,
          width: 200,
        },
        {
          Header: "RECEIPT_DATE",
          accessor: "RECEIPT_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "RECEIPT_AMOUNT",
          accessor: "RECEIPT_AMOUNT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
          filterable: true,
          width: 200,
        },
        {
          Header: "ACCOUNT_NO",
          accessor: "ACCOUNT_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "ACCOUNT_NAME",
          accessor: "ACCOUNT_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "BANK_ACCOUNT",
          accessor: "BANK_ACCOUNT",
          filterable: true,
          width: 200,
        },
        {
          Header: "PAYMENT_AMOUNT",
          accessor: "PAYMENT_AMOUNT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "PAYMENT_DATE",
          accessor: "PAYMENT_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "NO_EBUPOT",
          accessor: "NO_EBUKPOT",
          filterable: true,
          width: 200,
        },
        {
          Header: "UPLOAD_DATE_EBUPOT",
          accessor: "UPLOAD_DATE_EBUKPOT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "NILAI_EBUPOT",
          accessor: "NILAI_EBUKPOT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "TGL_FISIK_BUPOT",
          accessor: "TGL_FISIK_BUKPOT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },

        // {
        //   Header: "PRINCIPAL_CLAIM_ID",
        //   accessor: "PRINCIPAL_CLAIM_ID",
        //   filterable: true, width: 200,
        // },

        // {
        //   Header: "NOTES PARTICIPANTS",
        //   accessor: "NOTES",
        //   filterable: true, width: 200,
        // },
        {
          Header: "PRINCIPAL_NOTES",
          accessor: "NOTES",
          filterable: true,
          width: 200,
        },
        {
          Header: "E-Bupot Upload By",
          accessor: "EBUPOT_UPLOAD_BY",
          filterable: true,
          width: 200,
        },
        {
          Header: "E-Bupot Upload Date",
          accessor: "EBUPOT_UPLOAD_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "E-Bupot Download By",
          accessor: "EBUPOT_DOWNLOAD_BY",
          filterable: true,
          width: 200,
        },
        {
          Header: "E-Bupot Download Date",
          accessor: "EBUPOT_DOWNLOAD_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "AWB HO Submit to Principal",
          accessor: "AWB_HO_SUBMIT_TO_PRINCIPAL",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "NPWP",
          accessor: "NPWP",
          filterable: true,
          width: 200,
        },
        {
          Header: "NPWP Nama",
          accessor: "NPWP_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "NPWP Alamat",
          accessor: "NPWP_ADDRESS",
          filterable: true,
          width: 200,
        },
        {
          Header: "NITKU",
          accessor: "NITKU",
          filterable: true,
          width: 200,
        },
        {
          Header: "Tarif Bupot",
          accessor: "TARIF_BUKPOT",
          filterable: true,
          width: 200,
        },
        {
          Header: "No Ref Dokumen Bupot ",
          accessor: "NO_DOKUMEN_REF_BUKPOT",
          filterable: true,
          width: 200,
        }, // ! web coll interface
        {
          Header: "Masa Pajak",
          accessor: "MASA_PAJAK",
          filterable: true,
          width: 200,
        },
        {
          Header: "Tahun Pajak",
          accessor: "TAHUN_PAJAK",
          filterable: true,
          width: 200,
        },
        {
          Header: "Due Date Customer Refund",
          accessor: "DUE_DATE_CUSTOMER_REFUND",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        {
          Header: "Upload Bupot by Principal",
          accessor: "UPLOAD_BUKPOT_BY_PRINCIPAL",
          filterable: true,
          width: 200,
        },
        {
          Header: "Email Date",
          accessor: "EMAIL_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
        },
        // {
        //   Header: "TYPE",
        //   accessor: "TYPE",
        //   filterable: true,
        //   width: 200,
        // },
        // {
        //   Header: "Verified Reason",
        //   accessor: "VERIFIED_REASON",
        //   filterable: true,
        //   width: 200,
        // },
        // {
        //   Header: "DM Open Number",
        //   accessor: "DM_OPEN_NUMBER",
        //   filterable: true,
        //   width: 200,
        // },
        // {
        //   Header: "DM Open Date",
        //   accessor: "DM_OPEN_DATE",
        //   filterable: true,
        //   width: 200,
        //   Cell: (row) => (
        //     <span>
        //       <span>
        //         {row.value !== null && row.value !== "" && row.value !== "null"
        //           ? moment(new Date(row.value)).format("DD-MMM-YYYY")
        //           : ""}
        //       </span>
        //     </span>
        //   ),
        // },
        // {
        //   Header: "DM Open Amount",
        //   accessor: "DM_OPEN_AMOUNT",
        //   filterable: true,
        //   width: 200,
        //   Cell: (row) => (
        //     <div style={{ textAlign: "right" }}>
        //       <span>
        //         {row.value !== null && row.value !== "" && row.value !== "null"
        //           ? row.value.toLocaleString("en-US", {
        //             minimumFractionDigits: 2,
        //             maximumFractionDigits: 2,
        //           })
        //           : ""}
        //       </span>
        //     </div>
        //   ),
        // },
        // {
        //   Header: "DM Adjusted Amount",
        //   accessor: "DM_ADJUSTED_AMOUNT",
        //   filterable: true,
        //   width: 200,
        //   Cell: (row) => (
        //     <div style={{ textAlign: "right" }}>
        //       <span>
        //         {row.value !== null && row.value !== "" && row.value !== "null"
        //           ? row.value.toLocaleString("en-US", {
        //             minimumFractionDigits: 2,
        //             maximumFractionDigits: 2,
        //           })
        //           : ""}
        //       </span>
        //     </div>
        //   ),
        // },
        // {
        //   Header: "Saldo",
        //   accessor: "SALDO",
        //   filterable: true,
        //   width: 200,
        //   Cell: (row) => (
        //     <div style={{ textAlign: "right" }}>
        //       <span>
        //         {row.value !== null && row.value !== "" && row.value !== "null"
        //           ? row.value.toLocaleString("en-US", {
        //             minimumFractionDigits: 2,
        //             maximumFractionDigits: 2,
        //           })
        //           : ""}
        //       </span>
        //     </div>
        //   ),
        // },
        // {
        //   Header: "Status Bupot",
        //   accessor: "STATUS_BUKPOT",
        //   filterable: true,
        //   width: 200,
        // },
        //==============================================================
        //==============================================================
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };
  // TYPE
  // VERIFIED_REASON
  // DM_OPEN_NUMBER
  // DM_OPEN_DATE
  // DM_OPEN_AMOUNT
  // DM_ADJUSTED_AMOUNT
  // SALDO
  // STATUS_BUKPOT
  trandformDate = (dateString) => {
    var date = new Date(dateString);
    return moment(date).format("DD-MMM-YYYY");
  }

  donwload = () => {
    this.setState({ loading: true })
    const dataMaping = this.state.dataTable.map((value) => {
      return {
        BRANCH: value.BRANCH,
        SUBMIT_DATE_CLAIM: value.SUBMIT_DATE_CLAIM ? new Date(value.SUBMIT_DATE_CLAIM) : value.SUBMIT_DATE_CLAIM,
        AWB_NO_CABANG: value.AWB_NO_CABANG,
        AWB_NO_CABANG_SUBMIT_DATE: value.AWB_NO_CABANG_SUBMIT_DATE ? new Date(value.AWB_NO_CABANG_SUBMIT_DATE) : value.AWB_NO_CABANG_SUBMIT_DATE,
        AWB_RECEIPT_DATE_HO: value.AWB_RECEIPT_DATE_HO ? new Date(value.AWB_RECEIPT_DATE_HO) : value.AWB_RECEIPT_DATE_HO,
        PRINCIPAL_CODE: value.PRINCIPAL_CODE,
        AWB_NO_HO: value.AWB_NO_HO,
        LT_CAB_HO: value.LT_CAB_HO,
        AWB_RECEIPT_DATE_PRINCIPAL: value.AWB_RECEIPT_DATE_PRINCIPAL ? new Date(value.AWB_RECEIPT_DATE_PRINCIPAL) : value.AWB_RECEIPT_DATE_PRINCIPAL,
        PRINCIPAL_CLAIM_RECEIPT_DATE: value.PRINCIPAL_CLAIM_RECEIPT_DATE ? new Date(value.PRINCIPAL_CLAIM_RECEIPT_DATE) : value.PRINCIPAL_CLAIM_RECEIPT_DATE,
        LT_HO_PRINCIPAL: value.LT_HO_PRINCIPAL,
        PAYMENT_METHOD: value.PAYMENT_METHOD,
        KWITANSI: value.KWITANSI,
        CLAIM_NUMBER: value.CLAIM_NUMBER,
        STATUS: value.STATUS,
        APPROVED_REJECTED_DATE: value.APPROVED_REJECTED_DATE ? new Date(value.APPROVED_REJECTED_DATE) : value.APPROVED_REJECTED_DATE,
        REASON_REJECTED: value.REASON_REJECTED,
        LT_APPROVAL_PRINCIPAL: value.LT_APPROVAL_PRINCIPAL,
        CUST_INVOICE_NO: value.CUST_INVOICE_NO,
        PRINCIPAL_CLAIM_ID: value.PRINCIPAL_CLAIM_ID,
        PRINCIPAL_STATUS: value.PRINCIPAL_STATUS,
        CUSTOMER_GROUP: value.CUSTOMER_GROUP,
        CUSTOMER_NAME: value.CUSTOMER_NAME,
        PROGRAM_NUMBER: value.PROGRAM_NUMBER,
        PROGRAM_TYPE: value.PROGRAM_TYPE,
        PROGRAM_DESCRIPTIONS: value.PROGRAM_DESCRIPTIONS,
        REF_NUMBER: value.REF_NUMBER,
        TRACES_NUMBER: value.TRACES_NUMBER,
        START_DATE_PROGRAM: value.START_DATE_PROGRAM ? new Date(value.START_DATE_PROGRAM) : value.START_DATE_PROGRAM,
        END_DATE_PROGRAM: value.END_DATE_PROGRAM ? new Date(value.END_DATE_PROGRAM) : value.END_DATE_PROGRAM,
        CLAIM_EXP_DATE: value.CLAIM_EXP_DATE ? new Date(value.CLAIM_EXP_DATE) : value.CLAIM_EXP_DATE,
        NILAI_DPP: value.NILAI_DPP,
        NILAI_PPN: value.NILAI_PPN,
        TOTAL_CLAIM: value.TOTAL_CLAIM,
        PPH_TYPE: value.PPH_TYPE,
        PPH_RATE: value.PPH_RATE,
        NILAI_PPH: value.NILAI_PPH,
        CLAIM_NET: value.CLAIM_NET,
        NO_NPWP_RELASI: value.NO_NPWP_RELASI,
        NAMA_NPWP_RELASI: value.NAMA_NPWP_RELASI,
        ALAMAT_NPWP_RELASI: value.ALAMAT_NPWP_RELASI,
        TAX_NO: value.TAX_NO,
        TAX_DATE: value.TAX_DATE ? new Date(moment(value.TAX_DATE).utc().format('DD MMMM YYYY')) : value.TAX_DATE,
        SKB_NUMBER: value.SKB_NUMBER,
        AR_INVOICE_NUMBER: value.AR_INVOICE_NUMBER,
        SUPPLIER_NAME: value.SUPPLIER_NAME,
        SUPPLIER_SITE: value.SUPPLIER_SITE,
        AP_INVOICE_NUM: value.AP_INVOICE_NUM,
        COVER_LETTER_NUMBER: value.COVER_LETTER_NUMBER,
        COVER_LETTER_DATE: value.COVER_LETTER_DATE ? new Date(moment(value.COVER_LETTER_DATE).toString()) : value.COVER_LETTER_DATE,
        RECEIPT_NO_CABANG: value.RECEIPT_NO_CABANG,
        RECEIPT_DATE: value.RECEIPT_DATE ? new Date(value.RECEIPT_DATE) : value.RECEIPT_DATE,
        RECEIPT_AMOUNT: value.RECEIPT_AMOUNT,
        ACCOUNT_NO: value.ACCOUNT_NO,
        ACCOUNT_NAME: value.ACCOUNT_NAME,
        BANK_ACCOUNT: value.BANK_ACCOUNT,
        PAID_AMOUNT: value.PAYMENT_AMOUNT,
        PAYMENT_DATE: value.PAYMENT_DATE ? new Date(value.PAYMENT_DATE) : value.PAYMENT_DATE,
        NO_EBUPOT: value.NO_EBUKPOT,
        UPLOAD_DATE_EBUPOT: value.UPLOAD_DATE_EBUKPOT ? new Date(value.UPLOAD_DATE_EBUKPOT) : value.UPLOAD_DATE_EBUKPOT,
        NILAI_EBUPOT: value.NILAI_EBUKPOT,
        TGL_FISIK_BUPOT: value.TGL_FISIK_BUKPOT ? new Date(value.TGL_FISIK_BUKPOT) : value.TGL_FISIK_BUKPOT,
        NOTES: value.NOTES,
        EBUPOT_UPLOAD_BY: value.EBUPOT_UPLOAD_BY,
        EBUPOT_UPLOAD_DATE: value.EBUPOT_UPLOAD_DATE ? new Date(value.EBUPOT_UPLOAD_DATE) : value.EBUPOT_UPLOAD_DATE,
        EBUPOT_DOWNLOAD_BY: value.EBUPOT_DOWNLOAD_BY,
        EBUPOT_DOWNLOAD_DATE: value.EBUPOT_DOWNLOAD_DATE ? new Date(value.EBUPOT_DOWNLOAD_DATE) : value.EBUPOT_DOWNLOAD_DATE,
        AWB_HO_SUBMIT_TO_PRINCIPAL: value.AWB_HO_SUBMIT_TO_PRINCIPAL ? new Date(value.AWB_HO_SUBMIT_TO_PRINCIPAL) : value.AWB_HO_SUBMIT_TO_PRINCIPAL,
        NPWP: value.NPWP,
        NPWP_NAME: value.NPWP_NAME,
        NPWP_ADDRESS: value.NPWP_ADDRESS,
        NITKU: value.NITKU,
        TARIF_BUPOT: value.TARIF_BUKPOT,
        NO_DOKUMEN_REF_BUPOT: value.NO_DOKUMEN_REF_BUKPOT,
        UPLOAD_BUPOT_BY_PRINCIPAL: value.UPLOAD_BUKPOT_BY_PRINCIPAL,
        MASA_PAJAK: value.MASA_PAJAK,
        TAHUN_PAJAK: value.TAHUN_PAJAK,
        EMAIL_DATE: value.EMAIL_DATE ? new Date(value.EMAIL_DATE) : value.EMAIL_DATE,
        DUE_DATE_CUSTOMER_REFUND: value.DUE_DATE_CUSTOMER_REFUND ? new Date(value.DUE_DATE_CUSTOMER_REFUND) : value.DUE_DATE_CUSTOMER_REFUND,
        // TYPE: value.TYPE,
        // VERIFIED_REASON: value.VERIFIED_REASON,
        // DM_OPEN_NUMBER: value.DM_OPEN_NUMBER,
        // DM_OPEN_DATE: value.DM_OPEN_DATE ? new Date(value.DM_OPEN_DATE) : value.DM_OPEN_DATE,
        // DM_OPEN_AMOUNT: value.DM_OPEN_AMOUNT,
        // DM_ADJUSTED_AMOUNT: value.DM_ADJUSTED_AMOUNT,
        // SALDO: value.SALDO,
        // STATUS_BUPOT: value.STATUS_BUKPOT,
      }
    })

    const workBook = xlsx.utils.book_new();
    const workSheet = xlsx.utils.json_to_sheet(dataMaping, { dateNF: 'DD-MMM-YYYY', cellDates: true });
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(workBook, `traces-ho-${moment(new Date()).format("DDMMYYYYHHmmss")}.xlsx`, { cellDates: true });
    this.setState({ loading: false })
  }

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/assign/summary/" + row.program_customer_id);
  };

  handleSearch = () => {
    let url = "/api/traces/v1/report/reportho";
    let param = {
      export: this.state.export,
      org_id: this.state.setBranch,
      source: "arman",
      status: this.state.setStatus,
      active_status: this.state.activeStatus,
      principal: this.state.setPrincipal,
      customerid: this.state.customerId,
      ebupot_exist: this.state.bupotexist,
      awbho: this.state.awbho,
      awbcabang: this.state.awbcabang,
      from_date:
        this.state.fromDate != ""
          ? moment(new Date(this.state.fromDate)).format("YYYY-MM-DD")
          : "",
      to_date:
        this.state.toDate != ""
          ? moment(new Date(this.state.toDate)).format("YYYY-MM-DD")
          : "",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
      expdate:
        this.state.expDate != ""
          ? moment(new Date(this.state.expDate)).format("YYYY-MM-DD")
          : "",
    };

    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.data.map((item, index) => {
          //   item.formatted_start_date = moment(item.start_date).format(
          //     "DD-MM-YYYY"
          //   );
          //   item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          item.formatted_submit_date_claim = moment(
            item.submit_date_claim
          ).format("DD-MMM-YYYY");

          return item;
        });

        if (this.state.export) {
          let url = data.fullurl;
          window.open(url, "_blank");
        }
        this.setState({
          loading: false,
          dataTable: data.data,
          baseTable: data.data,
          export: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();

    console.log(this.state.dataTable);
  };

  handleChangeStatus = (e) => {
    this.state.setStatus = e.target.value;
  };

  handleChangeBupot = (e) => {
    this.state.bupotexist = e.target.value;
  };

  handleChangeBranch = (e) => {
    this.state.setBranch = e.target.value;
  };

  handleChangePrincipal = (e) => {
    this.state.setPrincipal = e.target.value;
  };

  handleChangeValue = (event) => {
    let value = event.target.value;
    let valname = event.target.name;

    // this.setState({ activeflag: value })

    if (valname === "org_id") {
      this.setState({ princid: value });
    }

    window.setTimeout(() => {
      console.log(valname);
    }, 100);
  };

  handleFind = () => {
    // let value = e.target.value
    // let url = '/api/traces/v1/report/reportprincipal'
    // let param = {
    //     "org_id": this.state.user.org_id,
    //     "status": this.state.setStatus,
    //     "from_date": moment(this.state.fromDate).format('YYYY-MM-DD'),
    //     "to_date":moment(this.state.toDate).format('YYYY-MM-DD'),
    //     "princlov" : this.state.princid

    // }

    let url = "/api/traces/v1/report/reportho";
    let param = {
      org_id: this.state.user.org_id,
      source: "arman",
      from_date: moment(this.state.fromDate).format("YYYY-MM-DD"),
      to_date: moment(this.state.toDate).format("YYYY-MM-DD"),
    };

    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else if (status === "S") {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    } else if (status === "S") {
      mappingStatus = "ASSIGN";
    }
    console.log(mappingStatus);
    return mappingStatus;
  };

  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleexpDate = (date) => {
    this.setState({ expDate: date });
  };

  handleExport = () => {
    this.setState({ export: true });
    let app = this;
    window.setTimeout(() => {
      app.handleSearch();
    }, 200);
  };

  handleChangeAwbCabang = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ awbcabang: value });
  };

  handleChangeAwbHO = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ awbho: value });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row mt-3"></div>

                            <div className="row">
                              <div className="col-md-2 mt-1">
                                Submitted Date From{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Submitted Date To{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Approved Date From{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.fromDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handlefromDate}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Approved Date To{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.toDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handletoDate}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Expired After{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.expDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleexpDate}
                                />
                              </div>
                              <div className="col-md-2">Claim Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatus.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="D">Draft</option>
                                  <option value="P">Propose</option>
                                  <option value="A">Approve</option>
                                  <option value="I">Invalid</option>
                                  <option value="E">Revise</option>
                                  <option value="R">Reject</option>
                                </select>
                              </div>
                              {/* <div className="col-md-2">Active Status</div>
                                                            <div className="col-md-3">
                                                                <select className="form-control" onChange={ this.handleChangeStatusActive.bind(this) }>
                                                                    <option value="">- Select Status -</option>
                                                                    <option value="Y">Active</option>
                                                                    <option value="N">Inactive</option>
                                                                </select>
                                                            </div> */}
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">Principal </div>
                              <div className="col-lg-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option key={index} value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">Branch</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="branchId"
                                  onChange={this.handleChangeBranch.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovBranch.map((item, index) => (
                                    <option
                                      value={item.org_id}
                                      key={index}
                                      selected={
                                        this.state.originOrgid == item.org_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {item.org_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2">E-Bupot</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeBupot.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="Y">Yes</option>
                                  <option value="N">No</option>
                                </select>
                              </div>
                              <div className="col-md-2">Customer</div>
                              <div className="col-md-3">
                                <Autocomplete
                                  id="customer_auto"
                                  onchange={this.onChangeAutocompleteCust.bind(
                                    this
                                  )}
                                  onselect={this.onSelectCustomer.bind(this)}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2">AWB No Cabang</div>
                              <div className="col-md-3">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  id="inputEmail3"
                                  name="awbcabang"
                                  // placeholder="Description"
                                  onChange={this.handleChangeAwbCabang.bind(
                                    this
                                  )}
                                  value={this.state.awbcabang}
                                />
                              </div>
                              <div className="col-md-2">AWB No HO</div>
                              <div className="col-md-3">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  id="inputEmail3"
                                  name="awbho"
                                  // placeholder="Description"
                                  onChange={this.handleChangeAwbHO.bind(this)}
                                  value={this.state.awbho}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.donwload.bind(this)}
                                >
                                  <i class="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
